import { Input } from '@amzn/awsui-components-react'

const TableDescriptionInput = (props) => {
    const { id, description, onDescriptionChange, readOnly = false } = props

    return (
        <Input
            value={description}
            onChange={({ detail }) => onDescriptionChange(id, 'description', detail.value)}
            readOnly={readOnly}
        ></Input>
    )
}

export default TableDescriptionInput
